import { checkIsApkInfoNonEmpty } from '../../../app-store/utils/check-is-apk-info-non-empty.util';
import { mapApkInfoModelToApkInfoDto } from '../../../app-store/utils/excepted-apps-mapping.util';
import { FileMetadataTypesEnum } from '../../enums/file-metadata-types.enum';
import { ApkInfoModel } from '../../models/apk-info.model';
import { createFileMetadata } from '../create-file-metadata/create-file-metadata.util';

export const createFileFormData = (
  file: File,
  fileType: FileMetadataTypesEnum,
  chunk: ArrayBuffer | null = null,
  apkInfo: ApkInfoModel | null = null
): FormData => {
  const formData = new FormData();
  const fileToAppend: File = chunk ? new File([chunk], file.name) : file;
  formData.append('file', fileToAppend);
  const fileMetadata = createFileMetadata(file, fileType);
  formData.append(
    'metaData',
    new Blob([JSON.stringify(fileMetadata)], {
      type: 'application/json',
    })
  );
  if (apkInfo && checkIsApkInfoNonEmpty(apkInfo)) {
    formData.append(
      'apkInfo',
      new Blob([JSON.stringify(mapApkInfoModelToApkInfoDto(apkInfo))], {
        type: 'application/json',
      })
    );
  }
  return formData;
};
